import BubbleBobbleImage from "@/assets/images/portfolio/BubbleBobbleClone.png";
import ShmupImage from "@/assets/images/portfolio/SampleShmupMechanics.png";
import NiivueImage from "@/assets/images/portfolio/NiivueReader_Pic01.png";
import RayMarchingImage from "@/assets/images/portfolio/Raymarching_sample_capture.png";
import DemoSceneBrasilImage from "@/assets/images/portfolio/DemoScene_Brasil.png";
import HM2Img from "@/assets/images/portfolio/HM2.png";
import type { SimpleIcon } from "simple-icons";
import * as si from "simple-icons";
export interface Project {
    id: number;
    titleKey: string;
    descriptionKey: string;
    category: string;
    image: string;
    itchioLink?: string;
    demoLink?: string;
    githubLink?: string;
    releaseDate: string;
    technologies: (string | SimpleIcon)[];
}

export const projects: Project[] = [
  {
    id: 1,
    titleKey: "portfolio.projects.game1.title",
    descriptionKey: "portfolio.projects.game1.description",
    category: "games",
    image: BubbleBobbleImage,
    itchioLink:
      "https://beveldrive.itch.io/sample-mechanics-bubble-bobble-clone",
    releaseDate: "Dez 2023",
    technologies: [si.siGodotengine, 'GDScript', "Pixel Art"],
  },
  {
    id: 2,
    titleKey: "portfolio.projects.game2.title",
    descriptionKey: "portfolio.projects.game2.description",
    category: "games",
    image: ShmupImage,
    itchioLink: "https://beveldrive.itch.io/sample-shmup-mechanics",
    releaseDate: "Aug 2022",
    technologies: [si.siGodotengine, 'GDScript'],
  },
  {
    id: 3,
    titleKey: "portfolio.projects.web1.title",
    descriptionKey: "portfolio.projects.web1.description",
    category: "webapps",
    image: NiivueImage,
    demoLink: "https://github.com/BrunoDG/NiiVueReader",
    githubLink: "https://github.com/BrunoDG/NiiVueReader",
    releaseDate: "Jan 2025",
    technologies: [
      si.siVuedotjs,
      si.siTypescript,
      si.siTailwindcss,
      si.siThreedotjs,
      si.siPython,
      si.siFastapi,
      'NiiVue',
    ],
  },
  {
    id: 4,
    titleKey: "portfolio.projects.web2.title",
    descriptionKey: "portfolio.projects.web2.description",
    category: "webapps",
    image: RayMarchingImage,
    itchioLink: "https://beveldrive.itch.io/raymarching-sample",
    releaseDate: "Sep 2017",
    technologies: [si.siJavascript, si.siThreedotjs],
  },
  {
    id: 5,
    titleKey: "portfolio.projects.web3.title",
    descriptionKey: "portfolio.projects.web3.description",
    category: "webapps",
    image: DemoSceneBrasilImage,
    demoLink: "https://demoscenebrasil.beveldrive.com.br",
    releaseDate: "May 2025",
    technologies: [si.siVuedotjs, si.siTypescript, si.siTailwindcss],
  },
  {
    id: 6,
    titleKey: "portfolio.projects.audio1.title",
    descriptionKey: "portfolio.projects.audio1.description",
    category: "audioapps",
    image: HM2Img,
    githubLink: 'https://github.com/BrunoDG/Swedish_Chainsaw_Zig',
    releaseDate: 'Sep 2026',
    technologies: [si.siRaylib, si.siZig, si.siC, 'Miniaudio', 'HM2'],
  },
  // ... outros projetos
];
